import React from 'react';
import useTheme from 'branding/theme';
import Circle from '../Circle';
import CheckIcon from '../../icons/utility/CheckIcon';
import MinusIcon from '../../icons/utility/MinusIcon';
const StatusCircle = ({ status = 'success', size = 'regular', disabled = false, inverted = false, styles }) => {
    const { colors } = useTheme();
    const Icon = status === 'fail' ? MinusIcon : CheckIcon;
    const iconSizeProps = size === 'tiny'
        ? { width: '80%', height: '80%', x: '10%', y: '10%' }
        : { width: '50%', height: '50%', x: '25%', y: '25%' };
    const mergedStyles = {
        ...(inverted && { borderColor: colors.neutrals.textAlpha }),
        ...(inverted && disabled && { borderColor: colors.neutrals.borderBeta }),
        ...styles
    };
    return (React.createElement(Circle, { kind: status, size: size, disabled: disabled, inverted: inverted, styles: mergedStyles },
        React.createElement(Icon, { type: status === 'regular' ? 'inverted' : 'utility', size: "small", ...iconSizeProps, disabled: disabled })));
};
export default StatusCircle;
//# sourceMappingURL=index.js.map